import React from 'react';
import { useParams } from 'react-router-dom';
import { SupportFeedPage } from '@components/feed-preview/support-feed-page';

const CommunityFeed = () => {
    const { communityId } = useParams();

    if (!communityId) {
        return null;
    }

    return (
        <SupportFeedPage
            entityId={Number(communityId)}
            entityType="community"
        />
    );
};

export default CommunityFeed;
